import axios from 'axios';
const endPoint = window.location.origin;
const getAppTypes = () => axios.get(`${endPoint}/data/apptypes.json`);

export {
    getAppTypes
}